import { Link } from 'react-router-dom';

const related = [
  {
    title: 'Stretch Tent Rental Guide: Tips and Considerations for Your Event',
    category: 'Stretch Tents',
    date: 'Jan 30, 2026',
    readTime: '5 mins read',
    image: '/assets/img/ddf123f33140.webp',
    slug: 'stretch-tent-rentals-guide-tips-considerations',
  },
  {
    title: "Enhance Your Festival's Appeal: Strategic Uses of Stretch Tents for Better Guest Experience",
    category: 'Stretch Tents',
    date: 'Feb 18, 2026',
    readTime: '5 mins read',
    image: '/assets/img/fe8d525f3474.webp',
    slug: 'enhance-festival-appeal-stretch-tents',
  },
  {
    title: 'Case Study: How Pop Pro Tents® Transformed the Experience at Lightning in a Bottle Festival',
    category: 'Stretch Tents',
    date: 'Mar 5, 2026',
    readTime: '7 mins read',
    image: '/assets/img/128b6f60dbc3.webp',
    slug: 'lightning-in-a-bottle-festival',
  },
];

export default function RelatedPosts() {
  return (
    <section className="bg-gray-50/60 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-8">Related Articles</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {related.map((post) => (
            <article
              key={post.slug}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="relative h-48 overflow-hidden bg-gray-100">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col gap-2.5">
                <span className="inline-block w-fit px-3 py-1 bg-teal-50 text-teal-600 text-xs font-bold rounded-full">
                  {post.category}
                </span>
                <h3 className="font-bold text-gray-900 text-sm leading-snug line-clamp-3">
                  {post.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-gray-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {post.date}
                  </span>
                  <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {post.readTime}
                  </span>
                </div>
                <Link
                  to={`/blog/${post.slug}`}
                  className="inline-flex items-center gap-1.5 text-teal-500 hover:text-teal-600 font-semibold text-sm mt-1 group/btn whitespace-nowrap"
                >
                  <span>Read More</span>
                  <i className="ri-arrow-right-line group-hover/btn:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 hover:border-teal-400 text-gray-700 hover:text-teal-600 px-8 py-3 rounded-lg font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Back to All Articles
          </Link>
        </div>
      </div>
    </section>
  );
}
